import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../atoms/button/button.atom';

import ImageLoader from '../../imageLoader';

import { MainMultiDisplayContainer } from './main-multi-display.styles';

const cardBoxStyle = {
    color: 'white',
    backgroundColor: 'rgba(224,223,218, 0.1)',
};

const coverStyle = {
    // height: '100%',
    width: '100%',
    height: 'auto',
    // maxHeight: '100%',
    backgroundColor: 'white',
};

const cardBannerStyle = {
    color: 'white',
    fontSize: '150%',
    fontWeight: 'bold',
    width: '100%',
    height: '100%',
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
};

const MainMultiDisplay = ({ displays = [] , defaultDisplay }) => {
    const initNoDisplayed = window.screen.width <= 1000 ? 2 : 4;
    const filtered = displays.slice(0, initNoDisplayed);

    const [expand, setExpand] = useState(filtered);
    const [buttonText, setButtonText] = useState('Show All');

    const toggleDisplay = () => {
        if (expand.length <= initNoDisplayed && displays.length > initNoDisplayed) {
            setExpand(displays);
            setButtonText('Show Less');
        } else {
            setExpand(filtered);
            setButtonText('Show All');
        }
    };

    useEffect(() => {
        setExpand(buttonText === 'Show All' ? filtered : displays);
    }, [displays, buttonText]);

    return (
        <MainMultiDisplayContainer>
            <div className='main-multi-box'>
            {/* <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                padding: '1rem',
            }}
            > */}
                {expand.map((display, i) => (
                    <Link to='' key={i} className='display'>
                        <div className='banner'>
                            <img loading='lazy' style={coverStyle} src={display.img} alt='' />
                        </div>
                    </Link>
                ))}
            </div>
             {/* </div> */}
            {displays.length > initNoDisplayed && (
                <Button 
                    text={buttonText}
                    style={{ width: '100%', padding: '0', margin: '0' }}
                    func={toggleDisplay}
                />
            )}
           
        </MainMultiDisplayContainer>
    );
};

export default MainMultiDisplay;
